import { Link } from 'react-router-dom';

import { useLanguage } from '../context/LanguageContext';
import { site } from '../data/site';
import Logo from './Logo';

function Footer() {
  const { language, t } = useLanguage();

  const note = language === 'ru'
    ? 'Апартаменты для аренды и покупки рядом с островом Святой‑Стефан.'
    : 'Apartments for rent and sale near the island of Sveti Stefan.';

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="footer__intro">
          <Logo inverse />
          <p>{note}</p>
        </div>

        <div className="footer__column">
          <span className="footer__label">{language === 'ru' ? 'Навигация' : 'Explore'}</span>
          <Link to="/residences">{t('navigation.residences')}</Link>
          <Link to="/sale">{t('navigation.sale')}</Link>
          <Link to="/location">{t('navigation.location')}</Link>
          <Link to="/book">{t('navigation.book')}</Link>
        </div>

        <div className="footer__column">
          <span className="footer__label">{language === 'ru' ? 'Адрес' : 'Address'}</span>
          <p>{site.location}</p>
          <a href={site.mapUrl} target="_blank" rel="noreferrer">
            {language === 'ru' ? 'Открыть карту ↗' : 'Open map ↗'}
          </a>
        </div>

      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} {site.name}</span>
        <span>Sveti Stefan · Montenegro</span>
      </div>
    </footer>
  );
}

export default Footer;
